export default class ExchangeBankFiltersModel {
  constructor(obj) {
    obj = obj || {};

    this.storeCity = obj.storeCity;
  }
}